/**
 * Push a lead/callback form success event to GTM dataLayer.
 * @param {string} eventName
 * @param {{phone_number?: string, email?: string}} [extra]
 */
export function pushFormGtmEvent(eventName, extra = {}) {
    if (typeof window === 'undefined' || !eventName) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    const payload = {event: eventName};
    if (extra.phone_number) {
        payload.phone_number = String(extra.phone_number).replace(/[\s\-\(\)]/g, '');
    }
    if (extra.email) {
        payload.email = extra.email;
    }

    window.dataLayer.push(payload);
}
